export const BUSINESS = {
  siteName: "Servani Safety Nets",
  phoneE164: "+917995792953",
  phoneDisplay: "+91 79957 92953",
  phoneUrl: "tel:+917995792953",
  whatsappUrl: "https://wa.me/917995792953",
  email: "contact@servanisafetynets.com",
  emailUrl: "mailto:contact@servanisafetynets.com",
  locations: [
    {
      id: "hebbal",
      label: "Hebbal location",
      googleProfileName: "Servani Invisible Grill for Balcony",
      googleProfileUrl: "https://share.google/S2jsDa2uU4wcu4QCk",
      address:
        "Patel Muniyappa Layout, Cholanayakanahalli, Hebbal, Bengaluru, Karnataka 560024",
      addressLines: [
        "Patel Muniyappa Layout, Cholanayakanahalli,",
        "Hebbal, Bengaluru, Karnataka 560024",
      ],
      streetAddress: "Patel Muniyappa Layout, Cholanayakanahalli, Hebbal",
      addressLocality: "Bengaluru",
      addressRegion: "Karnataka",
      postalCode: "560024",
      latitude: 13.0375357,
      longitude: 77.6027732,
      mapUrl:
        "https://www.google.com/maps/place/Servani+Invisible+Grill+for+Balcony/@13.0375357,77.6027732,17z/data=!4m6!3m5!1s0x3bae1799500a3a91:0x348bba52354855f6!8m2!3d13.0375357!4d77.6027732!16s%2Fg%2F11zx3bl420",
      embedUrl:
        "https://www.google.com/maps?q=13.0375357,77.6027732&hl=en&z=17&output=embed",
      directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=13.0375357%2C77.6027732",
    },
    {
      id: "bagaluru",
      label: "Bagaluru location",
      googleProfileName: "Servani Safety nets",
      googleProfileUrl: "https://share.google/LGplsbRCPCFc1IcZD",
      address:
        "Aerospace Park, Gummanahalli, Bagaluru, K.G.Huvinaikanahalli, Karnataka 562149",
      addressLines: [
        "Aerospace Park, Gummanahalli, Bagaluru,",
        "K.G.Huvinaikanahalli, Karnataka 562149",
      ],
      streetAddress: "Aerospace Park, Gummanahalli, Bagaluru",
      addressLocality: "K.G.Huvinaikanahalli",
      addressRegion: "Karnataka",
      postalCode: "562149",
      latitude: 13.1447313,
      longitude: 77.6842644,
      mapUrl:
        "https://www.google.com/maps/place/Servani+Safety+nets/@13.1447313,77.6842644,17z/data=!4m6!3m5!1s0x3bae1b6f9507e7e9:0x6ed4f20ab58e0ca8!8m2!3d13.1447313!4d77.6842644!16s%2Fg%2F11yn5j8mt8",
      embedUrl:
        "https://www.google.com/maps?q=13.1447313,77.6842644&hl=en&z=17&output=embed",
      directionsUrl:
        "https://www.google.com/maps/dir/?api=1&destination=13.1447313%2C77.6842644",
    },
  ],
} as const;
